// Static VR world layout + theme (client-side). Room enablement comes from API.
export const COLORS = {
  obsidian: "#05070a",
  panel: "#0a0e14",
  cyan: "#38e1ff",
  violet: "#8b5cff",
  mint: "#3effa8",
  amber: "#ff7a45",
  white: "#eaf6ff",
};

export const ROOM_BOUNDS = 17; // half-extent the player can walk in any room

// Atrium directional signage → fast travel targets, arranged in an arc.
export const ATRIUM_NAV = [
  { key: "gallery", label: "PEPTIDES", color: COLORS.cyan },
  { key: "research", label: "RESEARCH", color: COLORS.violet },
  { key: "scientists", label: "AI SCIENTISTS", color: COLORS.violet },
  { key: "quality", label: "QUALITY", color: COLORS.mint },
  { key: "calculator", label: "CALCULATOR", color: COLORS.cyan },
  { key: "checkout", label: "CHECKOUT", color: COLORS.mint },
];

// angle layout for N signs across a 200° arc in front of the DNA chamber
export function navTransforms(count, radius = 9) {
  const arr = [];
  const spread = (Math.PI * 1.15);
  const start = -spread / 2 - Math.PI / 2;
  for (let i = 0; i < count; i++) {
    const t = count === 1 ? 0.5 : i / (count - 1);
    const a = start + t * spread;
    arr.push({ x: Math.cos(a) * radius, z: Math.sin(a) * radius, angle: a });
  }
  return arr;
}

export const SCIENTIST_SPOTS = [
  { x: -5, z: -4 }, { x: 5, z: -4 }, { x: -5, z: 4 }, { x: 5, z: 4 },
];

// spawn position + yaw per room so the player faces the main content
export const SPAWN = {
  atrium: { pos: [0, 1.6, 13], yaw: 0 },
  gallery: { pos: [0, 1.6, 15], yaw: 0 },
  research: { pos: [0, 1.6, 11], yaw: 0 },
  quality: { pos: [0, 1.6, 10], yaw: 0 },
  calculator: { pos: [0, 1.6, 9], yaw: 0 },
  scientists: { pos: [0, 1.6, 12], yaw: 0 },
  checkout: { pos: [0, 1.6, 9], yaw: 0 },
};
